module.exports = __webpack_public_path__ + "img/qr-ios.9e4dfa5d.webp";